import { FaLongArrowAltRight } from "react-icons/fa";
import { projects } from "../../data";
import { Link } from "react-router-dom";

const Projects = () => {
    return (
        <section className="max-w-7xl mx-auto px-4 py-14 sm:py-20" id="projects">
            <div className="mb-2 sm:mb-5">
                <h2 className="font-semibold text-black text-4xl md:text-6xl">Selected <span className="text-primary pridi">Projects</span>.</h2>
                <p className="font-light text-sm sm:text-base text-black/70 w-full lg:w-1/2">
                    a showcase of practical projects demonstrating technical expertise, problem-solving skills, and attention to detail across frontend and backend development.
                </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {projects.map((project) => (
                    <div key={project.id} className="bg-white transition shadow-default border border-black flex flex-col justify-between saturate-100 lg:saturate-0 hover:saturate-100 hover:-translate-y-1 min-w-0">
                        <img src={project.images[0].url} alt={project.images[0].alt} loading="lazy" className="border-y border-black w-full h-52 sm:h-64 md:h-72 object-cover" />
                        <div className="p-3 flex flex-col gap-4">
                            <div className="text-2xl font-bold">{project.title}</div>
                            <p className="leading-5 text-sm text-black/70 line-clamp-3">{project.description}</p>
                            <div className="flex flex-wrap items-center gap-2">
                                {project.tech.map((tech, index) => (
                                    <div key={index} className="border-2 border-black py-1 px-3 text-xs bg-primary text-white">{tech}</div>
                                ))}
                            </div>
                            <Link to={`/detail/${project.id}`} rel="noreferrer" href={project.link} className="hover:underline flex flex-row items-center gap-2 w-fit">
                                view detail <FaLongArrowAltRight />
                            </Link>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    )
}

export default Projects
